import React from "react";
import { Link } from "react-router-dom";
import { Box, Button, Chip, IconButton, TableCell, TableRow, Tooltip, Typography } from "@material-ui/core";
import {
  ArchiveOutlined, AssignmentOutlined, CheckCircleOutline, ConfirmationNumberOutlined, DescriptionOutlined,
  Input, ListAltOutlined, MoreHoriz, PauseCircleOutline, SecurityOutlined, TimerOutlined,
} from "@material-ui/icons";
import formIconOptions from "@jumbo/constants/formIconOptions";
import useRecordListStyles from "../recordListStyles";
import useStyles from "./styles";

function subtitleText(value) {
  if (!value) return "";
  return new DOMParser().parseFromString(value, "text/html").body.textContent.replace(/\s+/g, " ").trim();
}

export default function FormElemnt({ data, mobile, busy, onMenu }) {
  const shared = useRecordListStyles();
  const classes = useStyles();
  const exam = data.type === "Exam";
  const Icon = formIconOptions.find(option => option.value === data.icon)?.Icon || DescriptionOutlined;
  const fields = data.fields || [];
  const questionCount = fields.filter(field => field.details?.examQuestion && field.details.type !== "Text").length;
  const subtitle = subtitleText(data.subtitle);
  const identity = <Box className={classes.identity}>
    <Box className={classes.icon} aria-hidden="true"><Icon /></Box>
    <Box className={classes.identityText}>
      <Box className={classes.badges}>
        <span className={classes.type}>{exam ? <AssignmentOutlined /> : <DescriptionOutlined />}{exam ? "آزمون" : data.type === "Signup" ? "ثبت‌نام" : "فرم"}</span>
      </Box>
      <Typography component={Link} to={`/formBuilder/${data._id}`} className={classes.title}>{data.title}</Typography>
      {subtitle && <Typography className={classes.subtitle}>{subtitle}</Typography>}
    </Box>
  </Box>;
  const status = <Box className={classes.statusList}>
    <Chip size="small" icon={data.active ? <CheckCircleOutline /> : <PauseCircleOutline />}
      label={data.active ? "فعال" : "غیرفعال"} className={`${shared.status} ${data.active ? shared.submitted : classes.inactive}`} />
    {data.archived && <Chip size="small" icon={<ArchiveOutlined />} label="بایگانی‌شده" className={`${shared.status} ${classes.archived}`} />}
  </Box>;
  const details = <Box className={classes.details}>
    <Typography className={classes.detail}><ListAltOutlined />{exam ? `بانک سوال: ${questionCount.toLocaleString("fa-IR")} سوال` : `${fields.length.toLocaleString("fa-IR")} فیلد`}</Typography>
    {exam && <Typography className={classes.detail}><TimerOutlined />{data.examSettings?.durationEnabled
      ? `${Number(data.examSettings.durationMinutes || 1).toLocaleString("fa-IR")} دقیقه` : "بدون محدودیت زمانی"}</Typography>}
    {data.privacyMode && <Typography className={classes.detail}><SecurityOutlined />حریم خصوصی فعال</Typography>}
  </Box>;
  const date = <Box>
    {mobile && <Typography className={shared.secondary}>تاریخ ایجاد</Typography>}
    <Typography className={classes.date}>{data.createdAt ? new Date(data.createdAt).toLocaleDateString("fa-IR", { timeZone: "Asia/Tehran" }) : "—"}</Typography>
  </Box>;
  const actions = <Box className={classes.actions}>
    <Button component={Link} to={`/forminputs/${data._id}?name=${encodeURIComponent(data.title)}`}
      variant="outlined" color="primary" size="small" startIcon={<Input />} className={shared.viewButton}>ورودی‌ها</Button>
    {exam && <Button component={Link} to={`/formtickets/${data._id}`} color="primary" size="small"
      startIcon={<ConfirmationNumberOutlined />} className={shared.viewButton}>مدیریت بلیط‌ها</Button>}
    <Tooltip title="عملیات فرم"><IconButton className={`${shared.moreButton} ${classes.moreAction}`} disabled={busy} aria-label={`عملیات فرم ${data.title}`}
      aria-haspopup="menu" onClick={event => onMenu?.(event, data)}><MoreHoriz /></IconButton></Tooltip>
  </Box>;

  if (mobile) return <Box component="article" aria-label={`فرم ${data.title}`} className={shared.mobileCard}>
    <Box className={`${shared.mobileCardHeader} ${classes.mobileHeader}`}>{identity}{status}</Box>
    <Box className={classes.mobileBody}>{details}{date}</Box>
    <Box className={`${shared.mobileCardFooter} ${classes.mobileFooter}`}>{actions}</Box>
  </Box>;

  return <TableRow>
    <TableCell>{identity}</TableCell>
    <TableCell>{status}</TableCell>
    <TableCell>{details}</TableCell>
    <TableCell>{date}</TableCell>
    <TableCell>{actions}</TableCell>
  </TableRow>;
}
